import React, {Component} from 'react';

//NOTE: built this for Azure AD component for now
//this may be reusable by other components later.
//If reused, we should move this out of Azure AD to a shared component list.

class InputField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputName: this.props.inputName,
      inputValue: this.props.inputValue
    }
  }

  render() {
    return (
        <div className="azure-name-placeholder">
          <input
              id={this.props.id}
              type="text"
              name={this.state.inputName}
              className="form-control app-name"
              value={this.state.inputValue}
              onChange={this.props.onChange}
              placeholder={this.props.placeholder}
          />
          <div className="field-error">
            {this.props.errorText}
          </div>
        </div>
    );
  }
}

export default InputField;